<div class="steps">
	<div
		class="step"
		*ngFor="let item of steps; let i = index"
		[ngClass]="{ active: stepActive === i }"></div>
</div>
